enum Action {
  MOVE = 'move',
  REPLACE = 'replace',
}

export default Action;
